const CreateShareDownloadModal = (options) => {
    // All variables required for internal global use. This way we don't need to play hot potato
    // and constantly pass everything back and forth between the functions.
    const body = document.querySelector(options.selectors.body);
    const closeModalBtn = document.querySelector(options.selectors.closeModalBtn);
    const copyBtn = document.querySelector(options.selectors.copyBtn);
    const desc = document.querySelector(options.selectors.desc);
    const downloadBtn = document.querySelector(options.selectors.downloadBtn);
    const linkInput = document.querySelector(options.selectors.linkInput)
    const modal = document.querySelector(options.selectors.modal)
    const shareBtn = document.querySelector(options.selectors.shareBtn);

    // Save the original description text for when modal is closed.
    let descOriginalText = '';

    /**
    * Takes in an array of required items and confirms whether everything exists.
    * 
    * @param {array} items 
    * 
    * @returns {boolean}
    */
    const __exists = (items) => {
        let valid = true;

        items.forEach(item => {
            if (item === undefined || item === null || item.length === 0) {
                valid = false;
            }
        });

        return valid;
    };

    /**
     * Toggle the modal open/close based off the value of openModal.
     */
    const __toggleModal = () => {
        let openModal = true;

        if (modal.classList.contains(options.class.active)) {
            openModal = false;
        }

        if (openModal) {
            body.setAttribute('style', 'overflow: hidden');
            modal.classList.add(options.class.active);
        } else {
            body.removeAttribute('style');
            modal.classList.remove(options.class.active);

            // Reset the modal description to the original text.
            desc.innerText = descOriginalText;
        }
    };

    /**
     * Copy page link to clipboard
     */
    const __copyLinkToClipboard = () => {
        // Select the text to be copied
        linkInput.select();
        linkInput.setSelectionRange(0, 99999);

        // Write to native navigator
        navigator.clipboard.writeText(linkInput.value);

        // Set description text to notify the user that the link has been copied.
        desc.innerText = 'Resource link has been copied to your clipboard!'
    };
    
    /**
     * Bind the event listeners to the relevant elements.
     */
    const __bind = () => {
        // Open modal when selecting the shareBtn
        shareBtn.addEventListener('click', () => {
            __toggleModal();
        });

        // Close modal when clicking the closeModalBtn
        closeModalBtn.addEventListener('click', () => {
            __toggleModal();
        });

        // Close modal when clicking the main modal wrapper
        modal.addEventListener('click', e => {
            if (e.target.classList.contains(options.class.active)) {
                __toggleModal();
            }
        });

        // Open native browser print popup when selecting the downloadBtn
        downloadBtn.addEventListener('click', () => {
            window.print();
        });

        // Copy the link to the clipboard
        copyBtn.addEventListener('click', () => {
            __copyLinkToClipboard();
        });
    };

    /**
     * Inject the page URL into the copy link input field.
     * 
     * @returns {void}
     */
    const __injectURL = () => {
        linkInput.value = window.location;
    };

    /**
     * The only publicly accessible function, which initialises the component.
     * 
     * @returns {void}
     */
    const init = () => {
        const requiredItems = [
            body,
            closeModalBtn,
            copyBtn,
            desc,
            downloadBtn,
            linkInput,
            modal,
            shareBtn
        ];

        if (__exists(requiredItems)) {
            descOriginalText = desc.innerText;

            __injectURL();
            __bind();
        } else {
            console.warn('Some required items missing for the Share Download Modal.');
        }
    };

    // Return a publicly accessible init function.
    return Object.freeze({
        init: init
    });
};

window.addEventListener('load', () => {
    const ShareDownloadModal = new CreateShareDownloadModal({
        selectors: {
            body: 'body',
            closeModalBtn: '.share-download-modal__close-button',
            copyBtn: '.share-download-modal__copy',
            desc: '.share-download-modal__desc',
            downloadBtn: '.share-download__download',
            linkInput: '.share-download-modal__link',
            modal: '.share-download-modal',
            shareBtn: '.share-download__share'
        },
        class: {
            active: 'active'
        }
    });

    ShareDownloadModal.init();
});